export default [/\/metrics\//i, /pinterest\.com/i];
